import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { UserLegalInfo } from 'src/app/shared/enums/enums'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
@Component({
  selector: 'ddc-cookiepolicy',
  templateUrl: './ddc-cookiepolicy.component.html',
  styleUrls: ['./ddc-cookiepolicy.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcTextGradientComponent],
})
export class DdcCookiepolicyComponent {
  _lastUpdate: string = UserLegalInfo.LAST_UPDATED
  _text: string = UserLegalInfo.COOKIE_POLICY
}
